<mat-dialog-content>
  <mat-card-title>{{ 'ecase.explorer.documentList.archive.title' | translate }}</mat-card-title>
  <p>{{ 'ecase.explorer.documentList.archive.confirmation' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button class="eCase-dialog-positive-action-button"
            [disabled]="submitting"
            [attr.aria-busy]="submitting"
            mat-raised-button
            (click)="onConfirm()">
      <span class="archive-confirm-content">
        <mat-spinner *ngIf="submitting"
                     [diameter]="20"
                     [attr.aria-label]="('ecase.explorer.documentList.archive.title' | translate) + '…'">
        </mat-spinner>
        <span>{{ 'ecase.explorer.documentList.archive.title' | translate }}</span>
      </span>
    </button>
    <button class="eCase-dialog-negative-action-button"
            [disabled]="submitting"
            (click)="onClose()"
            mat-raised-button>
      {{ 'ecase.common.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
